module.exports = "<mp-intro></mp-intro>\n<mp-path-reset-dialog></mp-path-reset-dialog>\n\n<div id=\"wrapper\">\n  <div class=\"container-fluid\">\n    <div class=\"row\">\n      <mp-main-menu></mp-main-menu>\n    </div>\n\n    <div class=\"row\">\n      <mp-sidebar class=\"sidebar-container\"></mp-sidebar>\n    </div>\n  </div>\n\n  <div id=\"main-content-wrapper\">\n    <div class=\"container-fluid\">\n      <div class=\"row\">\n        <router-outlet></router-outlet>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authenticated-app/authenticated-app.html
// module id = 2icn
// module chunks = 3